import React, { useContext, useCallback, useEffect } from 'react';
import { Input, Button, Form, Select, Row, Col } from 'antd';
import { FiltersContext } from '@CONTEXTS';
import { HJAddressSelectBox } from '@FORMS';

const Filters = () => {
  const { dispatch, filters } = useContext(FiltersContext);

  const setFilters = useCallback(
    (obj) => {
      dispatch({
        type: 'SET_FILTERS',
        payload: obj,
      });
    },
    [dispatch]
  );

  const onFinish = (values) => {
    const { barcode, customerDeliveryNo, deliveryType, warehouse } = values;
    const obj = {
      barcode,
      customerDeliveryNo,
      deliveryType,
      warehouse: warehouse?.warehouseId,
    };

    setFilters(obj);
  };

  useEffect(() => {
    resetFilters();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  const resetFilters = () => {
    dispatch({
      type: 'SET_FILTERS',
      payload: { barcode: null, customerDeliveryNo: null, deliveryType: null },
    });
  };

  return (
    <Row gutter={24}>
      <Form
        layout="inline"
        style={{ width: '100%' }}
        onFinish={(values) => onFinish(values)}
      >
        <Col span={4}>
          <Form.Item
            label={null}
            name="customerDeliveryNo"
            style={{ width: 200 }}
          >
            <Input
              placeholder="Sipariş Numarası"
              allowClear
              onChange={(e) => {
                const { value } = e.target;
                const { barcode } = filters;
                // value yoksa (çarpı butonuna tıklanmışsa) ve barkod değeri yoksa otomatik tekrar arasın
                if (
                  value === '' &&
                  (barcode === '' || barcode === null || barcode === undefined)
                ) {
                  resetFilters();
                }
              }}
            />
          </Form.Item>
        </Col>
        <Col span={4}>
          <Form.Item label={null} name="barcode" style={{ width: 200 }}>
            <Input
              placeholder="Gönderi Barkodu"
              allowClear
              onChange={(e) => {
                const { value } = e.target;
                const { customerDeliveryNo } = filters;
                // value yoksa (çarpı butonuna tıklanmışsa) ve sipariş numarası değeri yoksa otomatik tekrar arasın
                if (
                  value === '' &&
                  (customerDeliveryNo === '' ||
                    customerDeliveryNo === null ||
                    customerDeliveryNo === undefined)
                ) {
                  resetFilters();
                }
              }}
            />
          </Form.Item>
        </Col>
        <Col span={4}>
          <Form.Item
            label={null}
            name="deliveryType"
            style={{ width: 200 }}
            initialValue={null}
          >
            <Select
              placeholder="Gönderi Tipi"
              options={[
                { value: null, label: 'Tüm Gönderiler' },
                { value: 'HX_STD', label: 'Standart Teslimat' },
                { value: 'HX_ND', label: 'Ertesi Gün Teslimat' },
                {
                  value: 'XL',
                  label: 'XL Gönderiler',
                },
                {
                  value: 'POD',
                  label: 'Tahsilatlı Gönderiler',
                },
              ]}
            />
          </Form.Item>
        </Col>
        <Col span={4}>
          <Form.Item name="warehouse">
            <HJAddressSelectBox type="warehouse" placeholder="Çıkış Deposu" />
          </Form.Item>
        </Col>
        <Col span={4}>
          <Form.Item>
            <Button type="primary" block htmlType="submit">
              Ara
            </Button>
          </Form.Item>
        </Col>
      </Form>
    </Row>
  );
};

export default Filters;
